export default __webpack_public_path__ + "static/media/resumeInactive.cc4f51d3.png";